import { http_request } from "../interceptors/httpHandler";

export const getAllPlans = (data) => {
    return http_request("/masterdata/masterController/findAllPlan", "POST", data, true);
}

export const createOfferCode = data => {
    return http_request("/rest/v1/offer_code", "POST", data, true);
}

export const createOfferPlan = (data) => {
    return http_request("/rest/v1/plan_offer_master", "POST", data, true);
}

export const updateOfferCode = (data, id) => {
    return http_request(`/rest/v1/offer_code?id=eq.${id}`, "PATCH", data, true);
}

export const deleteOfferCode = (id) => {
    return http_request(`/rest/v1/offer_code?id=eq.${id}`, "DELETE", true);
}

export const updateOfferPlan = (data, plan_id) => {
    return http_request(`/rest/v1/plan_offer_master?plan_id=eq.${plan_id}`, "PATCH", data, true);
}

export const createRole = (data) => {
    return http_request("/masterdata/masterController/addRole", "POST", data, true);
}

export const updateRole = (data) => {
    return http_request("/masterdata/masterController/updateRole", "POST", data, true);
}

export const getRoleByState = (data) => {
    return http_request("/masterdata/masterController/findRoleByState", "POST", data, true);
}

export const updateRoleState = data => {
    return http_request('/masterdata/masterController/updateRoleState', 'POST', data)
}

export const getAllOfferPlans = () => {
    return http_request("/rest/v1/plan_offer_master?select=*&is_deleted=eq.0", "GET");
}

export const getAllRegionWisePlans = () => {
    return http_request('/masterdata/masterController/findAllRegionWisePlan', 'POST')
}

export const findOfferCodeByOfferIndentifier = offer_identifier => {
    return http_request(`/rest/v1/offer_code?select=*&offer_identifier=eq.${offer_identifier}&is_static=eq.1`, "GET");
}

export const findPlanById = (id) => {
    return http_request(`/rest/v1/plan_offer_master?plan_id=eq.${id}`, "GET", {}, true);
}

export const getRoleById = (id) => {
    return http_request(`/masterdata/masterController/findRoleById`, "POST", {
        data: id
    }, true);
}

export const updateOfferPlanState = (data) => {
    return http_request(`/masterdata/masterController/updateRegionWisePlanState`, 'PATCH', data)
}

export const getAllPermissonData = () => {
    return http_request(`/masterdata/masterController/getPermisssionData`, 'POST')
}

export const updateBanner = (data, id) => {
    return http_request(`/rest/v1/banner_master?id=eq.${id}`, "PATCH", data, true);
}

export const createBanner = data => {
    return http_request("/rest/v1/banner_master", "POST", data, true);
}

export const getAllBanners = () => {
    return http_request("/rest/v1/banner_master?select=*&is_deleted=eq.0", "GET");
}

export const getBannerById = (id) => {
    return http_request(`/rest/v1/banner_master?id=eq.${id}`, "GET", {}, true);
}